const R2_BUCKET_URL = 'https://pub-e952912157364d8bbd85042af745e4e8.r2.dev';

class DocumentFetcher {
  static getDocumentUrl(documentName) {
    // Encode the document name to handle spaces and special characters
    const encodedName = encodeURIComponent(documentName);
    return `${R2_BUCKET_URL}/${encodedName}`;
  }

  static openDocument(documentName) {
    const url = this.getDocumentUrl(documentName);
    window.open(url, '_blank');
  }
}

export default DocumentFetcher;